export default "__VITE_ASSET__Ca5_XOJD__"